// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"8f7f7579","146":"cd8532ed","169":"011aa540","242":"927a8f55","268":"fa9bc8d1","350":"a6e97649","511":"7ea687e9","663":"8bb9bff8","675":"7774b5c0","916":"06c65bf6","998":"eb10264d"}[chunkId] + ".chunk.js";
};